import { nanoid } from 'nanoid'
import modalStore from 'shared/ui/Modal/store/modalStore'
import { logger } from 'shared/lib'
import { type ActionItem, toastStore } from 'shared/ui'
import { ModalTypeList } from 'shared/ui/Modal/store/types'
import { SurveysApi } from 'entities/Surveys'

const deleteSurveyAction = async (id: number, onSuccessDelete: (id: number) => void) => {
  const modalId = nanoid()

  const onClose = () => {
    modalStore.closeModal(modalId)
  }

  const onDelete = async () => {
    try {
      await SurveysApi.deleteSurvey(id)
      onSuccessDelete(id)
      onClose()
      toastStore.add({
        type: 'success',
        title: 'Survey deleted',
      })
    } catch (error) {
      logger.error(error)
      toastStore.add({
        title: 'Something went wrong',
        desc: 'Please try again',
        type: 'error',
      })
    }
  }

  modalStore.addModal({
    id: modalId,
    type: ModalTypeList.ALERT,
    title: 'Delete survey?',
    desc: 'This action cannot be undone.',
    width: 280,
    secondaryAction: {
      text: 'Cancel',
      onAction: onClose,
    },
    primaryAction: {
      text: 'Delete',
      onAction: onDelete,
    },
  })
}

export const deleteSurvey = (id: number, onSuccessDelete: (id: number) => void): ActionItem => {
  return {
    text: 'Delete',
    icon: 'delete',
    group: 'Actions',
    onAction: () => deleteSurveyAction(id, onSuccessDelete),
  }
}
